<template>

    <div>
        
        <v-menu
            v-model="datePickerModal"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateFormatted"
                    :label="label"
                    v-on="on"
                    outlined
                    v-mask="mask"
                    v-bind="attrs"
                    :rules="rules"
                    :disabled="disabled"
                    @blur="dataValue = parseDate(dateFormatted); $emit('input', dataValue);"
                />
            </template>

            <v-date-picker :max="max" :min="min" locale="pt-br" v-model="dataValue" no-title @input="datePickerModal = false" v-on:input="dateFormatted = dateToString(dataValue); $emit('input', dataValue);"/>
        </v-menu>

    </div>

</template>

<script>
    import { mask } from "vue-the-mask";

    export default {
        name: "DatePickerField",

        directives: {
            mask
        },

        props: {
            label: String,
            data: String,
            max: null,
            min: null,
            rules: null,
            disabled: false
        },

        data() {
            return {
                datePickerModal: false,
                dataValue: this.data,
                mask: "##/##/####",
                dateFormatted: this.dateToString(this.data)
            }
        },

        methods: {
            
            dateToString(data) {
                if (!data) return null;
                const [year, month, day] = data.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate (date) {
                if (!date || date.length < 10) {
                    this.dateFormatted = '';
                    return null;
                }

                const [day, month, year] = date.split('/')
                const novaData = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                if (this.isValidDate(new Date(novaData))) {
                    return novaData;
                } else {
                    this.dateFormatted = '';
                    return null;
                }                
            },
            isValidDate(date) {
                return date instanceof Date && !isNaN(date);
            }
        },
        watch: {
            data(value) {
                this.dateFormatted = this.dateToString(value);
            }
        }
    }

</script>
